/**
 * @pps/query-keys — factory tipada de query keys React Query.
 *
 * Source-of-truth única para invalidation segura no monorepo (IR-RQ-001).
 * Resolve o débito de 266 query keys inline em 81 arquivos detectado na
 * auditoria de arquitetura (ver `audit-architecture-*.md`).
 *
 * Uso típico:
 *
 *   import { qk } from "@pps/query-keys";
 *
 *   useQuery({
 *     queryKey: qk.sales.leads.list(orgId, filters),
 *     queryFn: ...,
 *   });
 *
 *   queryClient.invalidateQueries({ queryKey: qk.sales.leads.all });
 *
 * Filosofia: *zero deps*. Cada key é um tuple readonly (`as const`),
 * sem proxies, sem builders mutáveis. Compatível com React Query v5.
 *
 * Migração: ver `README.md` (find/replace + anti-patterns).
 */
import { sales } from "./sales";
import { tournaments } from "./tournaments";
import { students } from "./students";
import { enrollments } from "./enrollments";
import { lessons } from "./lessons";
import { organizations } from "./organizations";
import { auth } from "./auth";
import { announcements } from "./announcements";
import { financial } from "./financial";
import { pdv } from "./pdv";
import { invoices } from "./invoices";
import { support } from "./support";
import { agenda } from "./agenda";
import { whatsapp } from "./whatsapp";
import { integrations } from "./integrations";
import { featureFlags } from "./featureFlags";
import { repasse } from "./repasse";
import { reservas } from "./reservas";
import { locacao } from "./locacao";
import { fiscal } from "./fiscal";
import { commissions } from "./commissions";
import { expenses } from "./expenses";
import { plataforma } from "./plataforma";

export const qk = {
  sales,
  tournaments,
  students,
  enrollments,
  lessons,
  organizations,
  auth,
  announcements,
  financial,
  pdv,
  invoices,
  support,
  agenda,
  whatsapp,
  integrations,
  featureFlags,
  repasse,
  reservas,
  locacao,
  fiscal,
  commissions,
  expenses,
  plataforma,
} as const;

export type QkRoot = typeof qk;

export { tuple } from "./core";
export type { QueryDomain, QueryFilters, QueryKey } from "./types";
export type { StudentViewScope } from "./students";
export type {
  AnnouncementStatusFilter,
  AnnouncementListFilters,
} from "./announcements";

export type { StudentInvoiceListFilters } from "./invoices";
export type { SupportTicketListFilters } from "./support";

// Re-export por domínio (para imports parciais via subpath).
export { sales, tournaments, students, enrollments, lessons, organizations, auth, announcements, financial, pdv, invoices, support, agenda, whatsapp, featureFlags, integrations, repasse, reservas, fiscal };
